import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { INSIGHTS_DRAWER_ID } from '~/views/insights/utils/const';

export const useInsightDrawer = () => {
  const { setQueryParams, deleteQueryParam } = useQueryParams();
  const { trackInsightsDrawerOpen } = usePosthogEvents();

  const openDrawer = (
    id: string,
    trackingProperties: Record<string, any> & { source: PosthogTrackingSource }
  ) => {
    const { source, ...rest } = trackingProperties;
    trackInsightsDrawerOpen(source, 'simple', rest);
    setQueryParams({
      [queryKeys.activeInsight]: id,
      [queryKeys.activeDrawer]: INSIGHTS_DRAWER_ID,
      [queryKeys.source]: JSON.stringify(trackingProperties),
    });
  };

  const closeDrawer = () => {
    deleteQueryParam(
      [queryKeys.activeInsight, queryKeys.activeDrawer, queryKeys.source],
      {
        replace: true,
      }
    );
  };

  return {
    openDrawer,
    closeDrawer,
  };
};
